import { LocationDto } from "@braoshzmvavz/picnube-common";
import { TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import React from "react";
import { useEffect, useMemo } from "react";
import ReactCountryFlag from "react-country-flag";
import { HiChevronLeft, HiChevronRight, HiSearch, HiX } from "react-icons/hi";
import { useAppSelector } from "src/app/hooks";

export default function LocationItem(props: {
  isLocationSelected: boolean;
  location: LocationDto;
  onLocationSelected: (location: LocationDto) => void;
  onLocationSelectedForDetail: (location: LocationDto) => void;
}) {
  return (
    <div
      className={`flex flex-row items-center justify-between dark:hover:bg-grey-900 hover:bg-grey-200 cursor-pointer p-2 px-4 border-b dark:border-grey-800 border-grey-400
    ${props.isLocationSelected ? "border-l-4 border-l-blue-500" : ""}`}
      onClick={() => props.onLocationSelected(props.location)}
    >
      <div className="flex flex-col">
        <div className="">{props.location.name}</div>
        <div className="text-sm text-grey-600"></div>
        <div className="text-xs text-grey-600 flex flex-row gap-2 items-center mt-1">
          <ReactCountryFlag
            style={{ fontFamily: "Twemoji Country Flags" }}
            countryCode={props.location.countryCode}
          ></ReactCountryFlag>
          <div>
            {props.location.region}, {props.location.country}
          </div>
        </div>
      </div>
      <div
        className="flex items-center gap-1 p-2 dark:hover:bg-grey-800 hover:bg-grey-300 cursor-pointer rounded-xl w-fit"
        onClick={(e) => {
          e.stopPropagation();
          props.onLocationSelectedForDetail(props.location);
        }}
      >
        <HiChevronRight className="text-xl"></HiChevronRight>
      </div>
    </div>
  );
}
